export default __webpack_public_path__ + "static/media/background.8385bb3c.jpg";